
class EventLogModel
{
  // ---------------------------------------------------------------------------------------------------------
	// --	EventLogModel
	// ---------------------------------------------------------------------------------------------------------

  constructor(contentStage, contentQuestionNum, questionStartAt)
  {
    //ステージ番号
    this.contentStage = contentStage

    //問題番号
    this.contentQuestionNum = contentQuestionNum

    //問題開始時間
    this.questionStartAt = questionStartAt

    //回答時間
    this.accessDt

    //回答した選択肢
    this.contentAnswer

    //結果
    this.contentResult

    //問題終了時間
    this.questionEndAt = 0
  }

  get data()
  {
    const data = {}
    data.accessDt = this.accessDt
    if(this.contentStage > 0) data.contentStage = String(this.contentStage)
    data.contentQuestionNum = String(this.contentQuestionNum)
    data.contentAnswer = String(this.contentAnswer)
    data.contentResult = String(this.contentResult)
    data.contentTrialTime = String(Math.floor((this.questionEndAt - this.questionStartAt)/1000))

    return data
  }

	// ---------------------------------------------------------------------------------------------------------
}

export default EventLogModel

